import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { Checkbox } from 'primereact/checkbox';

import { useAddCampaignContent, useAddPlaylistContent } from '../../../queries';
import { useScrollLoadingContext } from '../../Contexts/ScrollLoadingContext';
import { setLastElement } from '../../../redux/Slices/scrollSlice';
import { setDisableBtn } from '../../../redux/Slices/Global/globalSlice';
import ScrollContainer from '../ScrollContainer';


function HdmiList() {
    const { t } = useTranslation();
    const { isFetching, data, params } = useSelector((state) => state.scroll);
    const { assign, layer, campaignDetails } = useSelector((state) => state.global);
    const { setIds, ids } = useScrollLoadingContext();
    const screenDetails = useSelector((state) => state.layout.screenDetails);

    const addCampaignContent = useAddCampaignContent()
    const addPlaylistContent = useAddPlaylistContent()
    const lastElementRef = useRef(null);
    const dispatch = useDispatch();
    const { id } = useParams();

    const _params = {
        is_interactive: Number(campaignDetails?.is_interactive) ?? 0,
        section: "LINKS",
        layer: layer
    }

    useEffect(() => {
        if (ids?.length == 0) {
            dispatch(setDisableBtn(true))
        } else {
            dispatch(setDisableBtn(false))
        }
    }, [ids])

    useEffect(() => {
        if (assign) {
            dispatch(setDisableBtn(true))
            assignHandler()
        }
    }, [assign])

    const assignHandler = async () => {
        if (window.location.pathname.includes("campaign")) {
            await addCampaignContent.mutateAsync({
                "ids_list": ids,
                "campaign_id": id,
                "layer": layer,
                "type": "link",
            })
        }
        else if (window.location.pathname.includes("layout")) {
            await addCampaignContent.mutateAsync({
                "ids_list": ids,
                "campaign_id": screenDetails.id,
                "layer": layer,
                "type": "link",
            })
        }
        else {
            await addPlaylistContent.mutateAsync({
                "list_media_ids": ids,
                "playlist_id": id,
                "layer": layer,
            })
        }
    }

    const onMediaChange = (e) => {
        let selectedMedia = [...ids];

        if (e.checked)
            selectedMedia.push(e.value);
        else
            selectedMedia.splice(selectedMedia.indexOf(e.value), 1);

        (setIds(selectedMedia));
    }

    useEffect(() => {
        if (lastElementRef.current) {
            dispatch(setLastElement(lastElementRef.current));
        }
    }, [lastElementRef.current]);

    return (
        <>

            <ScrollContainer path={`/media`} optionalParam={_params}>
                {
                    !isFetching && data?.length == 0 ?
                        isEmpty(params?.search) ?
                            <h5 className="py-5 text-center w-100">{t('addcontent.no_links_yet')}</h5>
                            :
                            <h5 className="py-5 text-center w-100">{t('messages.no_results')}</h5>
                        :
                        <>
                            <div className="d-flex flex-column scroll_container scroll_div px-3 w-100">
                                <div className="d-flex flex-wrap mb-4">
                                    {
                                        data?.map((item, index) => {
                                            let imgEl = null;
                                            if (item.type === "HDMI") {
                                                imgEl = <div className={`p-4 d-flex bg-secondary align-items-center justify-content-center playlist_icon_container w-75`}>
                                                    <span className=" fs-6 text-white"> HDMI</span>
                                                </div>
                                            }

                                            return (
                                                item.type == "HDMI" &&
                                                (<div className={`w-100 d-flex align-items-center justify-content-between   py-2
                                                 ${ids.indexOf(`${item.id}`) !== -1 ? "bg-gray-200" : ""}
                                                  ${index + 1 != data?.length ? "border-bottom border-gray" : ""}  `}
                                                    ref={index === data?.length - 1 ? lastElementRef : null}
                                                    key={`${item.type} - ${index}`} >

                                                    <label htmlFor={item.id} className="col-11 d-flex ">
                                                        <div className="col-2 mx-2 "> {imgEl}  </div>
                                                        <div className="col-9 col-md-3 col-sm-6 mx-1 fs-6 d-flex align-items-center "> {item.file_name} </div>
                                                        {/* <div className="col-4 d-flex align-items-center justify-content-center text-capitalize d-none d-sm-block fs-6 text-light fs-6">
                                                            {item.type}
                                                        </div> */}
                                                    </label>
                                                    <Checkbox inputId={item.id} name="media" className='me-3' value={item.id} onChange={onMediaChange} checked={ids.indexOf(`${item.id}`) !== -1} />
                                                </div>)
                                            )
                                        })
                                    }
                                    {
                                        isFetching && data?.length ?
                                            <ProgressSpinner
                                                className='h-[50px] w-[50px] flex justify-center items-center my-4'
                                                strokeWidth="3"
                                                fill="var(--surface-ground)"
                                                animationDuration="30s" /> : <></>
                                    }
                                </div>
                            </div>
                        </>
                }
            </ScrollContainer>
        </>
    );
}

export default HdmiList